import * as React from "react";
import Autosuggest from "react-autosuggest";
import { ISearchProps, ISearchState } from "./Search.types";

const renderInputComponent = (inputProps) => {
  return (
    <span className="search">
      <input {...inputProps} />
      <input
        aria-label={inputProps["aria-label"]}
        className="search__button"
        type="submit"
        value=""
      />
    </span>
  );
};

function getSuggestionValue(suggestion) {
  return suggestion.query;
}

function shouldRenderSuggestions(value) {
  return value.trim().length > 2;
}

export class Search extends React.Component<ISearchProps, ISearchState> {
  private _queue: NodeJS.Timeout[] = [];
  private _autoWhateverItems: HTMLElement[];
  static defaultProps = {
    inputAriaLabel: "Sök",
    formAriaLabel: "Sök inom hela webbplatsen",
  };
  constructor(props: ISearchProps) {
    super(props);
    const initValue = props.value ? props.value : "";
    this._autoWhateverItems = [];
    this.state = {
      value: initValue,
      suggestions: [],
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      const suggestionElementHeader = document.getElementById(
        "react-autowhatever-search_siteheader"
      );
      const suggestionElementMobileHeader = document.getElementById(
        "react-autowhatever-search_mobile-siteheader"
      );
      const suggestionElementSearchPage = document.getElementById(
        "react-autowhatever-searchpage"
      );
      const suggestionElementCustomizedSection = document.getElementById(
        "react-autowhatever-search_customized"
      );
      const suggestionElementCustomizedSectionSearch = document.getElementById(
        "react-autowhatever-customized-search"
      );
      const suggestionContainerElements = document.querySelectorAll(
        ".react-autosuggest__container"
      );

      if (suggestionContainerElements) {
        var i;
        for (i = 0; i < suggestionContainerElements.length; i++) {
          if (
            this.findAncestor(
              suggestionContainerElements[i],
              ".search-result__form"
            )
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-searchpage"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-searchpage"
            );
          } else if (
            this.findAncestor(
              suggestionContainerElements[i],
              ".siteheader__small"
            )
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-search_mobile-siteheader"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-search_mobile-siteheader"
            );
          } else if (
            this.findAncestor(suggestionContainerElements[i], ".siteheader")
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-search_siteheader"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-search_siteheader"
            );
          } else if (
            this.findAncestor(
              suggestionContainerElements[i],
              ".customizedsection"
            )
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-search_customized"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-search_customized"
            );
          } else if (
            this.findAncestor(
              suggestionContainerElements[i],
              ".customizedsection-search"
            )
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-customized-search"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-customized-search"
            );
          } else if (
            this.findAncestor(suggestionContainerElements[i], ".search-list")
          ) {
            suggestionContainerElements[i].setAttribute(
              "aria-controls",
              "react-autowhatever-customized-search"
            );
            suggestionContainerElements[i].setAttribute(
              "aria-labelledby",
              "react-autowhatever-customized-search"
            );
          }
          suggestionContainerElements[i].removeAttribute("aria-owns");
        }
      }

      this._autoWhateverItems = [
        suggestionElementHeader,
        suggestionElementMobileHeader,
        suggestionElementSearchPage,
        suggestionElementCustomizedSection,
        suggestionElementCustomizedSectionSearch,
      ];

      this.setAriaHiddenForEmptyDiv("true");

      this._autoWhateverItems.forEach((el) => {
        if (el) {
          if (el?.id !== "react-autowhatever-customized-search") {
            el?.setAttribute("aria-label", "Sökfunktion som kan ge sökförslag");
          }
          el?.removeAttribute("role");
        }
      });
    }, 2000); //ITSM-6483
  };
  findAncestor = (el, sel) => {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el;
  };
  setAriaHiddenForEmptyDiv = (isHidden: string) => {
    this._autoWhateverItems.forEach((el) => {
      if (el?.getAttribute("aria-hidden") !== isHidden) {
        el?.removeAttribute("aria-hidden");
        el?.setAttribute("aria-hidden", isHidden);
      }
    });
  };

  getSuggestions = (findUrl, value) => {
    const url =
      findUrl +
      "/_autocomplete?prefix=" +
      encodeURIComponent(value.trim()) +
      "&size=5";

    return fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then((response) => {
      return response.json();
    });
  };

  delay = (interval: number) => {
    return new Promise((resolve) => {
      let item = setTimeout(resolve, interval);
      this._queue.push(item);
      while (this._queue.length > 1) {
        let toClear = this._queue.shift();
        clearTimeout(toClear);
      }
    });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.delay(500).then((_) => {
      this.getSuggestions(this.props.findUrl, value).then((data) => {
        this.setState(
          {
            suggestions: data.hits,
          },
          () => {
            const suggestionArray = this.state.suggestions as any;
            if (suggestionArray.length > 0) {
              this.setAriaHiddenForEmptyDiv("false");
            }
          }
        );
      });
    });
  };

  renderSuggestion(suggestion) {
    return suggestion.query;
  }

  onSuggestionsClearRequested = () => {
    this.setState(
      {
        suggestions: [],
      },
      () => {
        this.setAriaHiddenForEmptyDiv("true");
      }
    );
  };

  componentDidUpdate = (prevProps: ISearchProps) => {
    if (prevProps.focus !== this.props.focus) {
      if (this.props.focus) {
        document.getElementById(this.props.searchId).focus();
      }
    }
  };

  render(): JSX.Element {
    const { value, suggestions } = this.state;
    const { searchId, formCssClass, inputAriaLabel, formAriaLabel } =
      this.props;
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange,
      id: searchId,
      className: "search__field",
      type: "search",
      name: "q",
      //role: 'searchbox',
      "aria-label": inputAriaLabel,
    };

    return (
      <form
        action={this.props.searchPage}
        className={`search ${formCssClass}`}
        role="search"
        aria-label={formAriaLabel}
      >
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderInputComponent={renderInputComponent}
          inputProps={inputProps}
          shouldRenderSuggestions={shouldRenderSuggestions}
          id={searchId}
        />
      </form>
    );
  }
}
